import { gql } from '../../__generated__'

// Per-user delta feed (Phase 7). One query serves every per-user consumer:
// collection (userReleaseEntryStatuses, shaped identically to
// USER_GET_EXISTING_COLLECTIONS so it is a drop-in for the collection cache),
// list configs (userCustomLists), and curated membership (the two item lists,
// joined back to their list on the client). tombstones carry deletes.
export const GET_USER_CHANGES = gql(/* GraphQL */ `
  query GetUserChanges($sinceSeq: String!, $limit: Int) {
    userChanges(sinceSeq: $sinceSeq, limit: $limit) {
      userAdmins {
        id
        userId
        isGuest
        isAdmin
        isTester
        premiumTier
        premiumStartDate
        premiumLastRenewalDate
        createdAt
        adSkipTokens
      }
      userReleaseEntryStatuses {
        id
        collectionStatus
        currentReadStatus
        startDate
        endDate
        itemStatus
        miscItemStatus
        internalName
        publisherName
        type
        tagSearchField
        demographySearchField
        titleSearch
        totalVolumes
        totalNotReleasedVolumes
        totalReleasedVolumes
        lastCollectionChanged
        lastReadChanged
        createdAt
        compoundKey
        popularityScore
        recommendationScore
        entry {
          id
          status
          sortedVolumeNumbers
          notReleasedVolumeNumbers
          totalReleasedVolumes
          startDate
          endDate
        }
        readStatus {
          id
          finishedRead
          readStatus
          startedRead
          status
        }
      }
      userCustomLists {
        id
        urlName
        name
        description
        targetType
        mode
        isPublic
        isCustomTag
        customTagName
        customIcon
        removeWhenCollected
        removeWhenRead
        showTotalNumber
        showTotalValue
        statusFilter
        filter
        sort
        order
      }
      userCustomListReleaseEntryItems {
        id
        orderNumber
        list {
          id
        }
        releaseEntry {
          id
        }
      }
      userCustomListNoveltyItems {
        id
        orderNumber
        list {
          id
        }
        novelty {
          id
          entryId
          relationType
          relationId
          number
          volumeSuffix
          releaseItems
          collectionVolumeInfo {
            kind
          }
        }
      }
      tombstones {
        entity
        rowId
      }
      nextSeq
      headSeq
      hasMore
      resyncRequired
    }
  }
`)
